<template>
  <section>
    <div class="mx-auto">
      <div class="print-button d-flex">
        <p><i class="el-icon-info"></i> Click here for QC Charts</p>
        <el-button @click="printCharts()" round size="mini" type="primary">
          <i class="el-icon-printer"></i> PRINT</el-button
        >
      </div>
      <div class="results-section" id="qc-chart-print-view" v-if="!loading">
        <div class="title-block" v-if="$route.query.drug">
          <h3><span>Drug: </span>{{ $route.query.drug }}</h3>
          <h3>
            <span>From Date: </span>{{ formatDate($route.query.from_date) }}
          </h3>
          <h3><span>To Date: </span>{{ formatDate($route.query.to_date) }}</h3>
        </div>
        <div class="title-block" v-else>
          <h3>
            <span>From Date: </span>{{ formatDate($route.query.from_date) }}
          </h3>
          <h3><span>To Date: </span>{{ formatDate($route.query.to_date) }}</h3>
        </div>

        <div
          class="qc-page qc-page-1"
          v-if="
            (Qc1ReportData && Qc1ReportData.data && Qc1ReportData.data.length) ||
            (Qc2ReportData && Qc2ReportData.data && Qc2ReportData.data.length) ||
            (Qc3ReportData && Qc3ReportData.data && Qc3ReportData.data.length)
          "
        >
          <QC1
            v-if="Qc1ReportData && Qc1ReportData.data && Qc1ReportData.data.length"
            :qc1Data="Qc1ReportData"
            :chartHeight="400"
            class="chart-print-view"
          ></QC1>
          <QC2
            v-if="Qc2ReportData && Qc2ReportData.data && Qc2ReportData.data.length"
            :qc2Data="Qc2ReportData"
            :chartHeight="400"
            class="chart-print-view"
          ></QC2>
          <QC3
            v-if="Qc3ReportData && Qc3ReportData.data && Qc3ReportData.data.length"
            :qc3Data="Qc3ReportData"
            :chartHeight="400"
            class="chart-print-view"
          ></QC3>
        </div>

        <!-- Mgh QC1/2/3 page -->
        <div
          :class="['qc-page', hasQc1PageData ? 'qc-page-break' : '']"
          v-if="hasMghPage1Data"
        >
          <MghQC1
            v-if="MghQc1ReportData && MghQc1ReportData.data && MghQc1ReportData.data.length"
            :qc1Data="MghQc1ReportData"
            class="chart-print-view"
          ></MghQC1>
          <MghQC2
            v-if="MghQc2ReportData && MghQc2ReportData.data && MghQc2ReportData.data.length"
            :qc2Data="MghQc2ReportData"
            class="chart-print-view"
          ></MghQC2>
          <MghQC3
            v-if="MghQc3ReportData && MghQc3ReportData.data && MghQc3ReportData.data.length"
            :qc3Data="MghQc3ReportData"
            class="chart-print-view"
          ></MghQC3>
        </div>

        <!-- Mgh QC4 + Calibration page (same page) -->
        <div
          :class="['qc-page', (hasQc1PageData || hasMghPage1Data) ? 'qc-page-break' : '']"
          v-if="(MghQc4ReportData && MghQc4ReportData.data && MghQc4ReportData.data.length) || (Qc4ReportData && Qc4ReportData.data && Qc4ReportData.data.length)"
        >
          <MghQC4
            v-if="MghQc4ReportData && MghQc4ReportData.data && MghQc4ReportData.data.length"
            :qc4Data="MghQc4ReportData"
            class="chart-print-view"
          ></MghQC4>
          <QC4
            v-if="Qc4ReportData && Qc4ReportData.data && Qc4ReportData.data.length"
            :qc4Data="Qc4ReportData"
            :chartHeight="600"
            class="chart-print-view"
          ></QC4>
        </div>

        <!-- Preserved old print sections as comments (do not remove) -->
        <!--
        <div class="qc1arearetention-to-qc4arearetention">
          <QC1AreaRetention
            v-if="Qc1ReportData && Qc1ReportData.data && Qc1ReportData.data.length"
            :qc1Data="Qc1ReportData"
          ></QC1AreaRetention>
          <QC2AreaRetention
            v-if="Qc2ReportData && Qc2ReportData.data && Qc2ReportData.data.length"
            :qc2Data="Qc2ReportData"
          ></QC2AreaRetention>
          <QC3AreaRetention
            v-if="Qc3ReportData && Qc3ReportData.data && Qc3ReportData.data.length"
            :qc3Data="Qc3ReportData"
          ></QC3AreaRetention>
          <QC4AreaRetention
            v-if="Qc4ReportData && Qc4ReportData.data && Qc4ReportData.data.length"
            :qc4Data="Qc4ReportData"
          ></QC4AreaRetention>
        </div>

        <div class="mghqc1-arearetention">
          <MghQC1AreaRetention
            v-if="MghQc1ReportData && MghQc1ReportData.data && MghQc1ReportData.data.length"
            :qc1Data="MghQc1ReportData"
          ></MghQC1AreaRetention>
          <MghQC2AreaRetention
            v-if="MghQc2ReportData && MghQc2ReportData.data && MghQc2ReportData.data.length"
            :qc2Data="MghQc2ReportData"
          ></MghQC2AreaRetention>
          <MghQC3AreaRetention
            v-if="MghQc3ReportData && MghQc3ReportData.data && MghQc3ReportData.data.length"
            :qc3Data="MghQc3ReportData"
          ></MghQC3AreaRetention>
          <MghQC4AreaRetention
            v-if="MghQc4ReportData && MghQc4ReportData.data && MghQc4ReportData.data.length"
            :qc4Data="MghQc4ReportData"
          ></MghQC4AreaRetention>
        </div>

        <div>
          <UTAKHC
            v-if="utakhcData && utakhcData.data && utakhcData.data.length"
            :utakhcData="utakhcData"
          ></UTAKHC>
        </div>
        -->
      </div>
    </div>
  </section>
</template>
<script>
import QC1 from "@/components/QCCharts/QC1";
import QC2 from "@/components/QCCharts/QC2";
import QC3 from "@/components/QCCharts/QC3";
import QC4 from "@/components/QCCharts/QC4";
// import QC1AreaRetention from "@/components/QCCharts/QC1AreaRetention";
// import QC2AreaRetention from "@/components/QCCharts/QC2AreaRetention";
// import QC3AreaRetention from "@/components/QCCharts/QC3AreaRetention";
// import QC4AreaRetention from "@/components/QCCharts/QC4AreaRetention";
import MghQC1 from "@/components/QCCharts/microgen/QC1";
import MghQC2 from "@/components/QCCharts/microgen/QC2";
import MghQC3 from "@/components/QCCharts/microgen/QC3";
import MghQC4 from "@/components/QCCharts/microgen/QC4";
// import MghQC1AreaRetention from "@/components/QCCharts/microgen/QC1AreaRetention";
// import MghQC2AreaRetention from "@/components/QCCharts/microgen/QC2AreaRetention";
// import MghQC3AreaRetention from "@/components/QCCharts/microgen/QC3AreaRetention";
// import MghQC4AreaRetention from "@/components/QCCharts/microgen/QC4AreaRetention";
// import UTAKHC from "@/components/QCCharts/UTAKHC";
import { mapGetters } from "vuex";

export default {
  components: {
    QC1,
    QC2,
    QC3,
    QC4,
    // QC1AreaRetention,
    // QC2AreaRetention,
    // QC3AreaRetention,
    // QC4AreaRetention,
    MghQC1,
    MghQC2,
    MghQC3,
    MghQC4,
    // MghQC1AreaRetention,
    // MghQC2AreaRetention,
    // MghQC3AreaRetention,
    // MghQC4AreaRetention,
    // UTAKHC,
  },
  data() {
    return {
      loading: false,
      Qc1ReportData: { categories: [], data: [] },
      Qc2ReportData: { categories: [], data: [] },
      Qc3ReportData: { categories: [], data: [] },
      Qc4ReportData: { categories: [], data: [] },
      MghQc1ReportData: { categories: [], data: [] },
      MghQc2ReportData: { categories: [], data: [] },
      MghQc3ReportData: { categories: [], data: [] },
      MghQc4ReportData: { categories: [], data: [] },
      // utakhcData: { categories: [], data: [] },
    };
  },
  mounted() {
    this.fetchAndRender();
  },
  computed: {
    ...mapGetters("qcCharts", ["getQCChartReportData"]),
    hasQc1PageData() {
      return (
        (this.Qc1ReportData && this.Qc1ReportData.data && this.Qc1ReportData.data.length) ||
        (this.Qc2ReportData && this.Qc2ReportData.data && this.Qc2ReportData.data.length) ||
        (this.Qc3ReportData && this.Qc3ReportData.data && this.Qc3ReportData.data.length)
      );
    },
    hasMghPage1Data() {
      return (
        (this.MghQc1ReportData && this.MghQc1ReportData.data && this.MghQc1ReportData.data.length) ||
        (this.MghQc2ReportData && this.MghQc2ReportData.data && this.MghQc2ReportData.data.length) ||
        (this.MghQc3ReportData && this.MghQc3ReportData.data && this.MghQc3ReportData.data.length)
      );
    },
    hasAnyChartBeforeCalibration() {
      return (
        this.hasQc1PageData ||
        this.hasMghPage1Data ||
        (this.MghQc4ReportData && this.MghQc4ReportData.data && this.MghQc4ReportData.data.length)
      );
    },
  },
  methods: {
    printCharts() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.setPageTitle();
          this.prepareChartsForPrint();
          window.print();
        }, 120);
      });
    },
    prepareChartsForPrint() {
      const charts = [
        window.qc1Chart,
        window.qc2Chart,
        window.qc3Chart,
        window.qc4Chart,
        window.mghQc1Chart,
        window.mghQc2Chart,
        window.mghQc3Chart,
        window.mghQc4Chart,
      ].filter((chart) => chart && typeof chart.update === "function");

      charts.forEach((chart) => {
        chart.update(
          {
            chart: {
              marginLeft: 74,
              marginRight: 190,
              spacingLeft: 6,
              spacingRight: 6,
            },
            legend: {
              width: 58,
              x: -34,
              padding: 2,
              symbolWidth: 7,
              itemStyle: {
                fontSize: "8px",
              },
            },
          },
          false
        );

        if (chart.tooltip && typeof chart.tooltip.hide === "function") {
          chart.tooltip.hide(0);
        }

        chart.reflow();
        chart.redraw(false);
      });
    },
    async fetchAndRender() {
      this.loading = true;
      const q = this.$route.query;
      const only_utakhc = q.only_utakhc === "1";

      const params = {
        from_date: q.from_date,
        to_date: q.to_date,
        only_utakhc,
        only_qc_data_file: q.only_qc_data_file === "1",
      };

      if (!only_utakhc) {
        params.drug = q.drug;
        params.test = q.test;
        params.levels = q.levels ? q.levels.split(",") : [];
      }

      if (q.include_all_files === "1") {
        params.include_all_files = true;
      } else if (q.include_files) {
        params.include_files = q.include_files.split(",");
      }

      await this.$store.dispatch("qcCharts/fetchQCChartReportData", params);

      const data = this.getQCChartReportData;
      if (data) {
        this.Qc1ReportData = data.qcl ? { ...data.qcl } : { categories: [], data: [] };
        this.Qc2ReportData = data.qcm ? { ...data.qcm } : { categories: [], data: [] };
        this.Qc3ReportData = data.qch ? { ...data.qch } : { categories: [], data: [] };
        this.Qc4ReportData = data.calibration ? { ...data.calibration } : { categories: [], data: [] };
        this.MghQc1ReportData = data.qc1 ? { ...data.qc1 } : { categories: [], data: [] };
        this.MghQc2ReportData = data.qc2 ? { ...data.qc2 } : { categories: [], data: [] };
        this.MghQc3ReportData = data.qc3 ? { ...data.qc3 } : { categories: [], data: [] };
        this.MghQc4ReportData = data.qc4 ? { ...data.qc4 } : { categories: [], data: [] };
        // this.utakhcData = data.utakhc ? { ...data.utakhc } : { categories: [], data: [] };
      }

      this.loading = false;
      this.setPageTitle();

      this.$nextTick(() => {
        setTimeout(() => {
          this.printCharts();
        }, 800);
      });
    },
    setPageTitle() {
      const q = this.$route.query;
      if (q.drug) {
        document.title = `${q.drug}_${q.from_date}_${q.to_date}`;
      } else {
        document.title = `UTAK HC1_${q.from_date}_${q.to_date}`;
      }
    },
    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${month}-${day}-${year}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.print-button {
  text-align: right;
  margin: 1em auto;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 0px 10px 10px;
  margin-bottom: 20px;
  border-bottom: 1px dashed #dddddd;
  p {
    color: #727272;
    font-weight: 500;
    margin: 0;
    font-size: 0.85em;
    line-height: 1;
  }
}
.results-section {
  margin: 0 auto;
}
#qc-chart-print-view {
  width: 100%;
  max-width: 1000px;
}
.qc-page-2 {
  page-break-before: always;
}
.title-block {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  h3 {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    span {
      color: #555;
      font-weight: 700;
    }
  }
}
</style>

<style>
@media print {
  body * {
    visibility: hidden;
  }
  .print-button {
    display: none !important;
  }
  #qc-chart-print-view {
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
  }
  #qc-chart-print-view,
  #qc-chart-print-view * {
    visibility: visible;
  }
  #qc-chart-print-view {
    position: relative;
    left: auto;
    top: auto;
  }

  .chart-print-view {
    page-break-before: auto !important;
    page-break-inside: avoid !important;
  }

  @page {
    size: A4;
    margin: 10mm 12mm 12mm 12mm;
  }

  .title-block {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    padding: 0;
    border-bottom: none;
  }
  .title-block h3 {
    margin: 0;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
  }
  .title-block h3 span {
    font-weight: 700;
  }
  #qc-chart-print-view .el-card {
    margin-bottom: 2px !important;
    box-shadow: none !important;
    border: 3px solid #b8c0cd !important;
  }
  #qc-chart-print-view .el-card__body {
    padding: 4px !important;
  }
  #qc-chart-print-view #qc1ChartContainer,
  #qc-chart-print-view #qc2ChartContainer,
  #qc-chart-print-view #qc3ChartContainer,
  #qc-chart-print-view #mghQc1ChartContainer{
    min-height: 350px !important;
    height: 350px !important;
    width: 100% !important;
    margin: 0 !important;
  }
  #qc-chart-print-view #mghQc2ChartContainer{
    min-height: 450px !important;
    height: 450px !important;
    width: 100% !important;
    margin: 0 !important;
  }  #qc-chart-print-view #mghQc3ChartContainer {
    min-height: 450px !important;
    height: 450px !important;
    width: 100% !important;
    margin: 0 !important;
  }
  #qc-chart-print-view #qc4ChartContainer,
  #qc-chart-print-view #mghQc4ChartContainer {
    min-height: 550px !important;
    height: 550px !important;
    width: 100% !important;
    margin: 0 !important;
  }
  .highcharts-scrollbar {
    display: none;
  }
  #qc-chart-print-view .highcharts-plot-border {
    stroke-width: 2px !important;
    stroke: #9da8ba !important;
  }
  #qc-chart-print-view .highcharts-legend-box {
    stroke-width: 2px !important;
    stroke: #8f96a3 !important;
  }
  .qc-page-2 {
    page-break-before: always;
  }
  .qc-page-break {
    page-break-before: always;
  }
}
</style>
